<template>
  <div id="app">
    <router-view/>
    <div class="footer-bottom">
      <div class="container">
        <div class="footer-bottom-inner">
          <p class="copyright">
            © {{ new Date().getFullYear() }} 贵州创亿宝能节能科技有限公司. All Rights Reserved.
          </p>
          <div class="footer-legal">
            <a href="http://beian.miit.gov.cn/" target="_blank">备案号：黔ICP备20007001号</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      
    }
  },
  created() {},
  methods: {
    
  }
}
</script>
<style>
@import "./assets/fonts/iconfonts.css";
/* 底部信息 */
.footer-bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  right: 0;
  background: #d9dfe7;
  color: #5a6a7e;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 1280px;
}

.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.copyright {
  font-size: 0.85rem;
}

.footer-legal {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
}

.footer-legal a {
  color: var(--text-gray);
  transition: all .3s cubic-bezier(.4, 0, .2, 1);;
  text-decoration: none;
}

.footer-legal a:hover {
  color: #00b8e6;
}


/* 响应式 */
@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }
  
  .footer-brand {
    grid-column: 1 / -1;
    max-width: none;
  }
}

@media (max-width: 600px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .footer-bottom-inner {
    flex-direction: column;
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue